<template>
  <!-- Table Container Card -->
  <b-card
    no-body
  >
    <div class="m-2">
      <b-row>
        <b-col
          cols="12"
          md="6"
          class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
        >
          <!-- Per Page -->
          <list-per-page
            :total="total"
            :current-per-page="perPage"
            @onChangePerPage="changePerPage"
          />
        </b-col>
        <!-- Search -->
        <b-col
          cols="12"
          md="6"
        >
          <div class="d-flex align-items-center justify-content-end">
            <list-search @onSearch="search" />
          </div>
        </b-col>
      </b-row>
    </div>
    <table-loader v-if="loader" />
    <bank-receipts-list
      v-else
      :fields="fields"
      :items="items"
      :sort-key="sortKey"
      :sort-type="sortType"
      :additional-data="additionalData"
      :list-filters="additionalData.filters"
      :filters="filters"
      @onSortByChange="changeSortKey"
      @onSortDescChange="changeSortType"
      @onFilterChange="filterChange"
      @onFilterButtonClicked="getData"
      @onDeleteButtonClicked="deleteButtonClicked"
    />

    <list-pagination
      :current="page"
      :current-per-page="perPage"
      :from="from"
      :to="to"
      :total="total"
      :total-page="totalPage"
      @onChangePage="changePage"
    />
  </b-card>
</template>

<script>
import { ListIndex } from '../../common/mixins/list'
import BankReceiptsList from '../../components/bank-receipts/list/BankReceiptsList'

export default {
  components: {
    BankReceiptsList,
  },
  mixins: [ListIndex],
  data() {
    return {
      routeName: 'bank-receipts',
      userFields: [
        {
          key: 'display_type',
          label: this.$t('Type'),
        },
        {
          key: 'bank_name',
          label: this.$t('Bank name'),
        },
        {
          key: 'number',
          label: this.$t('Number'),
        },
        {
          key: 'tracking_number',
          label: this.$t('Tracking number'),
        },
        {
          key: 'payment_at',
          label: this.$t('Payment at'),
          sortable: true,
        },
        {
          key: 'status',
          label: this.$t('Status'),
        },
        {
          key: 'confirmed_at',
          label: this.$t('Confirmed at'),
          sortable: true,
        },
        {
          key: 'action',
          label: '',
        },
      ],
      adminFields: [
        {
          key: 'display_type',
          label: this.$t('Type'),
        },
        {
          key: 'bank_name',
          label: this.$t('Bank name'),
        },
        {
          key: 'number',
          label: this.$t('Number'),
        },
        {
          key: 'tracking_number',
          label: this.$t('Tracking number'),
        },
        {
          key: 'payment_at',
          label: this.$t('Payment at'),
          sortable: true,
        },
        {
          key: 'status',
          label: this.$t('Status'),
        },
        {
          key: 'confirmed_at',
          label: this.$t('Confirmed at'),
          sortable: true,
        },
        {
          key: 'action',
          label: '',
        },
      ],
    }
  },
  created() {
    if (this.$route.name === 'payments-show') {
      this.customParams.payment_id = this.$route.params.id
    } else {
      const column = {
        key: 'payment_id',
        label: this.$t('Payment'),
      }
      this.userFields.unshift(column)
      this.adminFields.unshift(column)
    }
  },
}
</script>

<style lang="scss">

</style>
